import I18n from '@/rI18n';
import * as yup from 'yup';
import Schema from '@/schema/Schema';
import Constant from '@/common/constant/Constant';
import TelephoneConstant from '@/common/constant/TelephoneConstant';
import Utils from '@/common/utils/utils';
import { getRichTextFieldContent } from '@/component/ticketList/handler/TicketHandler';
import { cloneDeep } from 'lodash';
import { AutoPassSystemFieldInSchema } from '@/common/constant/SystemField';
import moment from 'moment';

const CustomSchema = (fieldListData) => {
    fieldListData = [...fieldListData].filter(field => !AutoPassSystemFieldInSchema.includes(field.sysField));
    let validateObj = {};
    if (fieldListData.length) {
        fieldListData.forEach((field) => {
            if (!Utils.isEmptyObject(field)) {
                field = cloneDeep(field);
                let schemaValidate;

                switch (field.type) {
                    // Field text
                    case Constant.FORM_TYPE.FIELD_TEXT:
                        schemaValidate = yup
                            .string()
                            .transform(value => (value !== null ? String(value).trim() : ''));
                        if (field.sysField === Constant.SYS_FIELD.MAIL_SUBJECT) {
                            schemaValidate = schemaValidate.test({
                                message: I18n.get('MSG-EMAIL-TICKET-PROJECT-NAME-OVER'),
                                name: 'maxLength',
                                test(value) {
                                    if (!value) {
                                        return true;
                                    }
                                    if (value.length <= Number(2000)) {
                                        return true;
                                    } else {
                                        return false;
                                    }
                                },
                            });
                        }

                        if (field.structure.maxLength) {
                            schemaValidate = schemaValidate.test({
                                message: `${field.structure.maxLength}文字以下で入力してください。`,
                                name: 'maxLength',
                                test(value) {
                                    if (!value) {
                                        return true;
                                    }
                                    if (value.length <= Number(field.structure.maxLength)) {
                                        return true;
                                    } else {
                                        return false;
                                    }
                                },
                            });
                        }
                        if (field.structure.minLength) {
                            schemaValidate = schemaValidate.test({
                                message: `${field.structure.minLength}文字以上で入力してください。`,
                                name: 'minLength',
                                test(value) {
                                    if (!value) {
                                        return true;
                                    }
                                    if (value.length >= Number(field.structure.minLength)) {
                                        return true;
                                    } else {
                                        return false;
                                    }
                                },
                            });
                        }
                        if (field.structure.inputFormat) {
                            let errorMsg = I18n.get('ERROR_MSG_TEXT_FIELD_INVALID_FORMAT');
                            if (field?.sysField === Constant.SYS_FIELD.BUSINESS_APP_NAME)
                                errorMsg = I18n.get(
                                    'ERROR_MSG_FIELD_BUSINESS_APP_NAME_INVALID_FORMAT'
                                );
                                
                            schemaValidate = schemaValidate.test({
                                message: errorMsg,
                                name: 'input format',
                                test(value) {
                                    if (!value) {
                                        return true;
                                    }
                                    const inputFormat = field.structure.inputFormat;
                                    const regexString = new RegExp(inputFormat);;
                                    const isMatCh = regexString.test(value);

                                    if (!isMatCh) {
                                        return false;
                                    } else {
                                        return true;
                                    }
                                },
                            });
                        }
                        {
                            let isSDautoScriptForm = fieldListData.some(item => item.sysField?.toLowerCase() === Constant.SYS_FIELD.SDAUTO_SCRIPT);
                            if (isSDautoScriptForm && [Constant.SYS_FIELD.OUTLINE].includes(field?.sysField)) {
                                schemaValidate = schemaValidate.test({
                                    message: I18n.get('MSG-SD-VALID-SCRIPT-TITLE'),
                                    name: 'isValidBase62Title',
                                    test(value) {
                                        if (!value) return true;
                                        return Utils.isEmptyString(value) || Utils.isBase62(value);
                                    },
                                });
                            
                                schemaValidate = schemaValidate.test({
                                    message: I18n.get('MSG-SD-VALID-ITERATOR-TITLE'),
                                    name: 'isValidIteratorTitle',
                                    test(value) {
                                        return !value.toLowerCase().includes(Constant.ITERATOR);
                                    },
                                });
                            }
                        }
                        break;

                    // Field int
                    case Constant.FORM_TYPE.FIELD_INT:
                        schemaValidate = yup
                            .number()
                            .typeError('数字を入力してください。')
                            .nullable(true)
                            .transform((_, val) => (val ? Number(val) : null));

                        let maxValue = !Utils.isEmptyString(field.structure.maxValue)
                            ? field.structure.maxValue
                            : Constant.NUMBER_FIELD_DEFAULT.MAX_VALUE;
                        
                        // Special validation message for telephone_human_score field
                        const isTelephoneHumanScore =
                            field.sysField === TelephoneConstant.TELEPHONE.SYSTEM_FIELD.HUMAN_SCORE;
                        const customValidationMessage = isTelephoneHumanScore
                            ? I18n.get('MSG-TELEPHONE-VALID-HUMAN-SCORE')
                            : null;
                        
                        schemaValidate = schemaValidate.test({
                            message:
                                customValidationMessage ||
                                I18n.get('MSG-FIELD-VALID-MAX-VALUE').replace(
                                    Constant.FIELD_VALID_INTEGER.MAX_VALUE,
                                    maxValue
                                ),
                            name: 'maxValue',
                            test(value) {
                                if (!value?.toString()?.length) {
                                    return true;
                                }
                                if (value <= Number(maxValue)) {
                                    return true;
                                } else {
                                    return false;
                                }
                            },
                        });

                        let minValue = !Utils.isEmptyString(field.structure.minValue)
                            ? field.structure.minValue
                            : Constant.NUMBER_FIELD_DEFAULT.MIN_VALUE;
                        schemaValidate = schemaValidate.test({
                            message:
                                customValidationMessage ||
                                I18n.get('MSG-FIELD-VALID-MIN-VALUE').replace(
                                    Constant.FIELD_VALID_INTEGER.MIN_VALUE,
                                    minValue
                                ),
                            name: 'minValue',
                            test(value) {
                                if (!value?.toString()?.length) {
                                    return true;
                                }
                                if (value >= Number(minValue)) {
                                    return true;
                                } else {
                                    return false;
                                }
                            },
                        });

                        if (field.structure.integerOnly === true) {
                            schemaValidate = schemaValidate.test({
                                message: customValidationMessage || I18n.get('MSG-FIELD-VALID-INTEGER-ONLY'),
                                name: 'integerOnly',
                                test(value) {
                                    if (!value) {
                                        return true;
                                    }
                                    value = value.toString();

                                    const integerRegex = /^[-+]?\d+$/;
                                    const isInteger = integerRegex.test(value);

                                    if (!isInteger) {
                                        return false;
                                    } else {
                                        return true;
                                    }
                                },
                            });
                        }
                        break;

                    // Field date
                    case Constant.FORM_TYPE.FIELD_DATE:
                    case Constant.FORM_TYPE.FIELD_DATE_TIME:
                    case Constant.FORM_TYPE.FIELD_TIME:
                        schemaValidate = yup.string().nullable();
                        // Case ai auto timer
                        if (field?.structure?.minutesStep) {
                            schemaValidate = schemaValidate.test({
                                name: 'minutesStepCheck',
                                test(value) {
                                    if (value === undefined || value === null || value.trim() === '') {
                                        return true;
                                    }

                                    const { status, errorMessage } = Utils.validateDateByMinutesStep(
                                        value,
                                        field.structure.minutesStep
                                    );
                                    return status || this.createError({ message: errorMessage });
                                }
                            });
                    } else {
                        schemaValidate = schemaValidate.test({
                            name: 'dateFormat',
                            test(value) {
                                if (value === undefined || value === null || value.trim() === '') {
                                    return true;
                                }
    
                                    let formatRegex;
                                    let momentFormat;

                                    const dateFormat = field.structure.dateFormat;
                                    switch (dateFormat) {
                                        case Constant.SETTING_DATE_FIELD_FORMAT.YYYYMMDD:
                                            formatRegex = /^(\d{4})[/](\d{2})[/](\d{2})$/;
                                            momentFormat = Constant.MOMENT_DATE_FORMAT.YYYYMMDD;
                                            break;
                                        case Constant.SETTING_DATE_FIELD_FORMAT.YYYYMM:
                                            formatRegex = /^(\d{4})[/](\d{2})$/;
                                            momentFormat = Constant.MOMENT_DATE_FORMAT.YYYYMM;
                                            break;
                                        case Constant.SETTING_DATE_FIELD_FORMAT.YYYY:
                                            formatRegex = /^(\d{4})$/;
                                            momentFormat = Constant.MOMENT_DATE_FORMAT.YYYY;
                                            break;
                                        case Constant.SETTING_DATE_FIELD_FORMAT.HHMM:
                                            formatRegex = /^(\d{2}):(\d{2})$/;
                                            momentFormat = Constant.MOMENT_DATE_FORMAT.HHMM;
                                            break;
                                        case Constant.SETTING_DATE_FIELD_FORMAT.YYYYMMDD_HHMMSS:
                                            formatRegex = /^(\d{4})[/](\d{2})[/](\d{2}) (\d{2}):(\d{2}):(\d{2})$/;
                                            momentFormat = Constant.MOMENT_DATE_FORMAT.YYYYMMDD_HHMMSS;
                                            break;
                                        case Constant.SETTING_DATE_FIELD_FORMAT.HHMMSS:
                                            formatRegex = /^(\d{2}):(\d{2}):(\d{2})$/;
                                            momentFormat = Constant.MOMENT_DATE_FORMAT.HHMMSS;
                                            break;
                                        case Constant.SETTING_DATE_FIELD_FORMAT.YYYYMMDD_HHMM:
                                        default:
                                            formatRegex = /^(\d{4})[/](\d{2})[/](\d{2}) (\d{2}):(\d{2})$/;
                                            momentFormat = Constant.MOMENT_DATE_FORMAT.YYYYMMDD_HHMM;
                                            break;
                                    }

                                    const matches = formatRegex.test(value);
                                    if (!matches) return false;

                                    const momentValue = moment(value, momentFormat, true);
                                    return momentValue.isValid();
                                },
                                message: I18n.get('USER07MSG001')
                            });
                        }
                        break;

                    // Field iframe
                    case Constant.FORM_TYPE.FIELD_IFRAME:
                        schemaValidate = yup.string();
                        schemaValidate = schemaValidate.test({
                            message: I18n.get('COMMSG015'),
                            name: 'iframeFormat',
                            test(value) {
                                if (!value) {
                                    return true;
                                }

                                const isValid = Utils.validateURL(value);
                                if (!isValid) {
                                    return false;
                                }

                                return true;
                            },
                        });
                        break;

                    // Field URL
                    case Constant.FORM_TYPE.FIELD_URL:
                        schemaValidate = yup.string();
                        schemaValidate = schemaValidate.test({
                            message: I18n.get('COMMSG015'),
                            name: 'urlFormat',
                            test(value) {
                                if (!value) {
                                    return true;
                                }

                                let arrUrl = value.split(/\r?\n/);
                                let statusValidate = true;

                                if (Utils.isEmptyArray(arrUrl)) {
                                    return;
                                }
                                for (let i = 0; i < arrUrl.length; i++) {
                                    if (arrUrl[i]) {
                                        statusValidate = Utils.validateURL(arrUrl[i]);
                                        if (!statusValidate) {
                                            break;
                                        }
                                    }
                                }

                                return statusValidate;
                            },
                        });
                        break;
                    
                    // Field RichText
                    case Constant.FORM_TYPE.FIELD_RICHTEXT:
                        schemaValidate = yup.string();

                        if (field?.structure?.required) {
                            schemaValidate = schemaValidate.test({
                                message: I18n.get('COMMSG014'),
                                name: 'validateRequire',
                                test(value) {
                                    if (!getRichTextFieldContent(value)) {
                                        return false;
                                    }
                                    return true;
                                },
                            });
                        }

                        // Validate max length
                        // if (field?.structure?.maxLength) {
                        //     let maxLength = field?.structure?.maxLength;
                        //     schemaValidate = schemaValidate.test({
                        //         message: `${maxLength}文字以下で入力してください。`,
                        //         name: 'validateRequire',
                        //         test(value) {
                        //             let textContent = getRichTextFieldContent(value);
                        //             if (textContent.length > parseInt(maxLength)) {
                        //                 return false;
                        //             }
                        //             return true;
                        //         },
                        //     });
                        // }

                        break;
                    case Constant.FORM_TYPE.MERMAID:
                        schemaValidate = yup.string().trim();
                        if (field?.structure?.required) {
                            schemaValidate = schemaValidate.test({
                                message: I18n.get('COMMSG014'),
                                name: 'validateRequire',
                                test(value) {
                                    if (!value) {
                                        return false;
                                    }
                                    return true;
                                },
                            });
                        }
                        break;
                    case Constant.FORM_TYPE.HTML:
                        schemaValidate = yup.string().trim();
                        if (field?.structure?.required) {
                            schemaValidate = schemaValidate.test({
                                message: I18n.get('COMMSG014'),
                                name: 'validateRequire',
                                test(value) {
                                    if (!value) {
                                        return false;
                                    }
                                    return true;
                                },
                            });
                        }
                        break;
                    case Constant.FORM_TYPE.MARKDOWN:
                        schemaValidate = yup.string().trim();
                        if (field?.structure?.required) {
                            schemaValidate = schemaValidate.test({
                                message: I18n.get('COMMSG014'),
                                name: 'validateRequire',
                                test(value) {
                                    if (!value) {
                                        return false;
                                    }
                                    return true;
                                },
                            });
                        }
                        break;
                    default:
                        break;
                }

                if (schemaValidate && field?.structure?.required) {
                    // Skip required validation for AI Telephone conditional fields
                    // Required will be validated manually, but min/max/integer still validate realtime
                    const skipRequiredValidationFields = [
                        Constant.SYSTEM_FIELD.AI_TELEPHONE_TIME_BASED_DELAY_RESPONSE
                    ];
                    
                    if (!skipRequiredValidationFields.includes(field.sysField)) {
                        schemaValidate = schemaValidate.required(I18n.get('COMMSG014'));
                    }
                }

                let msgCodeFormat = 'COMM01MSG08';
                if (field.definition === Constant.FORM_DEFINITION.SYSTEM && ['customerEmail', 'adminMailAdress'].includes(field.sysField)) {
                    msgCodeFormat = 'COMM01MSG07';
                    field.structure.regExpr = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                }
                if (field.structure.regExpr) {
                    schemaValidate = schemaValidate.matches(
                        field.structure.regExpr,
                        I18n.get(msgCodeFormat)
                    );
                }

                if (schemaValidate) {
                    validateObj[field.id] = schemaValidate;
                }
            }
        });
    }
    return Schema.object().shape(validateObj);
};

export default CustomSchema;
